/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Clear_Selection_ButtonInputs */

const en_explorer_display_clear_selection_button = /** @type {(inputs: Explorer_Display_Clear_Selection_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Selection`)
};

const fr_explorer_display_clear_selection_button = /** @type {(inputs: Explorer_Display_Clear_Selection_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer la selection`)
};

const de_explorer_display_clear_selection_button = /** @type {(inputs: Explorer_Display_Clear_Selection_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auswahl löschen`)
};

const it_explorer_display_clear_selection_button = /** @type {(inputs: Explorer_Display_Clear_Selection_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella selezione`)
};

const ru_explorer_display_clear_selection_button = /** @type {(inputs: Explorer_Display_Clear_Selection_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить выбор`)
};

const es_explorer_display_clear_selection_button = /** @type {(inputs: Explorer_Display_Clear_Selection_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar selección`)
};

const zh_cn2_explorer_display_clear_selection_button = /** @type {(inputs: Explorer_Display_Clear_Selection_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除选择`)
};

const ja_explorer_display_clear_selection_button = /** @type {(inputs: Explorer_Display_Clear_Selection_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択をクリア`)
};

const hi_explorer_display_clear_selection_button = /** @type {(inputs: Explorer_Display_Clear_Selection_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयन साफ़ करें`)
};

const pt_pt2_explorer_display_clear_selection_button = /** @type {(inputs: Explorer_Display_Clear_Selection_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar seleção`)
};

/**
* | output |
* | --- |
* | "Clear Selection" |
*
* @param {Explorer_Display_Clear_Selection_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_clear_selection_button = /** @type {((inputs?: Explorer_Display_Clear_Selection_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Clear_Selection_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_clear_selection_button(inputs)
	if (locale === "de") return de_explorer_display_clear_selection_button(inputs)
	if (locale === "it") return it_explorer_display_clear_selection_button(inputs)
	if (locale === "ru") return ru_explorer_display_clear_selection_button(inputs)
	if (locale === "es") return es_explorer_display_clear_selection_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_clear_selection_button(inputs)
	if (locale === "ja") return ja_explorer_display_clear_selection_button(inputs)
	if (locale === "hi") return hi_explorer_display_clear_selection_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_clear_selection_button(inputs)
	return en_explorer_display_clear_selection_button(inputs)
});